(function () {
  var header = document.querySelector('header');
  if (!header) return;
  var root = document.documentElement;

  function syncHeaderVars() {
    root.style.setProperty('--sp-header-h', header.offsetHeight + 'px');
    root.style.setProperty('--sp-header-bottom', Math.max(header.getBoundingClientRect().bottom, 0) + 'px');
  }
  syncHeaderVars();
  window.addEventListener('resize', syncHeaderVars);
  window.addEventListener('scroll', syncHeaderVars, { passive: true });
  window.addEventListener('load', syncHeaderVars);
  if (window.ResizeObserver) new ResizeObserver(syncHeaderVars).observe(header);

  /* Mobile search overlay — keeps the field above the keyboard */
  var search = header.querySelector('.sp-hsearch');
  var input = header.querySelector('.sp-hsearch__input');
  var closeBtn = header.querySelector('.sp-hsearch__close');
  var overlayOpen = false;
  var savedScroll = 0;

  function isMobileSearch() {
    return window.innerWidth < 992;
  }

  function syncSearchViewport() {
    if (!search || !overlayOpen) return;
    var vv = window.visualViewport;
    var vh = (vv && vv.height) || window.innerHeight;
    search.style.setProperty('--sp-search-vh', vh + 'px');
    search.style.top = vv ? Math.max(vv.offsetTop, 0) + 'px' : '0px';
  }

  function lockBody() {
    savedScroll = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScroll + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBody() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScroll);
  }

  function patchPredictiveClose() {
    if (!search || !search.close || search._spClosePatched) return;
    search._spClosePatched = true;
    var origClose = search.close.bind(search);
    search.close = function (clearSearchTerm) {
      if (overlayOpen && !clearSearchTerm) return;
      origClose(clearSearchTerm);
    };
  }

  function openSearchOverlay() {
    if (!search || !isMobileSearch()) return;
    if (!overlayOpen) {
      overlayOpen = true;
      document.documentElement.classList.add('sp-search-open');
      search.classList.add('is-overlay');
      lockBody();
      patchPredictiveClose();
    }
    syncSearchViewport();
    requestAnimationFrame(function () {
      if (input && document.activeElement !== input) {
        input.focus({ preventScroll: true });
      }
    });
  }

  function closeSearchOverlay() {
    if (!overlayOpen) return;
    overlayOpen = false;
    document.documentElement.classList.remove('sp-search-open');
    if (search) {
      search.classList.remove('is-overlay');
      search.style.removeProperty('--sp-search-vh');
      search.style.top = '';
    }
    unlockBody();
    if (search && document.activeElement && search.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }

  function isCloseControl(el) {
    return !!(el && el.closest && el.closest('.sp-hsearch__close'));
  }

  if (search && input) {
    search.addEventListener('focusin', function (e) {
      if (isCloseControl(e.target)) return;
      openSearchOverlay();
    });
    search.addEventListener('pointerdown', function (e) {
      if (!isMobileSearch()) return;
      if (isCloseControl(e.target)) return;
      openSearchOverlay();
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeSearchOverlay();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlayOpen) closeSearchOverlay();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 992) closeSearchOverlay();
      else if (overlayOpen) syncSearchViewport();
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncSearchViewport);
      window.visualViewport.addEventListener('scroll', syncSearchViewport);
    }
    if (document.activeElement === input || search.contains(document.activeElement)) {
      openSearchOverlay();
    }
  }

  /* Animated placeholder */
  if (input) {
    var base = input.getAttribute('data-sp-placeholder-base') || input.placeholder;
    var tryLabel = input.getAttribute('data-sp-placeholder-try') || 'Try';
    var terms = (input.getAttribute('data-sp-placeholder-terms') || '')
      .split(',')
      .map(function (t) { return t.trim(); })
      .filter(Boolean);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (terms.length && !reduced && !isMobileSearch()) {
      var phrases = [base];
      terms.forEach(function (t) { phrases.push(tryLabel + ' "' + t + '"'); });
      var phraseIndex = 0;
      var charIndex = base.length;
      var deleting = false;
      var timer = null;

      var tick = function () {
        if (document.activeElement === input || input.value) {
          input.placeholder = base;
          timer = setTimeout(tick, 600);
          return;
        }
        var phrase = phrases[phraseIndex];
        var delay = deleting ? 28 : 55;
        if (!deleting) {
          charIndex++;
          if (charIndex >= phrase.length) {
            charIndex = phrase.length;
            deleting = true;
            delay = phraseIndex === 0 ? 3200 : 1800;
          }
        } else {
          charIndex--;
          if (charIndex <= 0) {
            charIndex = 0;
            deleting = false;
            phraseIndex = (phraseIndex + 1) % phrases.length;
            delay = 250;
          }
        }
        input.placeholder = phrases[phraseIndex].slice(0, charIndex) || '\u200a';
        timer = setTimeout(tick, delay);
      };
      deleting = true;
      timer = setTimeout(tick, 3200);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var el = document.activeElement;
      var tag = el && el.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (el && el.isContentEditable)) return;
      e.preventDefault();
      input.focus();
    });
  }

  /* Trustpilot score + review count */
  var badges = document.querySelectorAll('[data-sp-tp]');
  if (!badges.length) return;
  var bu = badges[0].getAttribute('data-bu');
  if (!bu) return;

  var colorFor = function (stars) {
    if (stars >= 4.5) return '#00b67a';
    if (stars >= 4) return '#73cf11';
    if (stars >= 3) return '#ffce00';
    if (stars >= 2) return '#ff8622';
    return '#ff3722';
  };

  var render = function (data) {
    badges.forEach(function (badge) {
      badge.querySelectorAll('[data-sp-tp-count]').forEach(function (el) {
        el.textContent = data.total;
      });
      badge.querySelectorAll('.sp-tp__star').forEach(function (star, i) {
        var fill = Math.max(0, Math.min(1, data.stars - i)) * 100;
        star.style.setProperty('--fill', fill + '%');
        star.style.setProperty('--tp-color', colorFor(data.stars));
      });
      badge.setAttribute('aria-label', 'Trustpilot ' + data.score + '/5, ' + data.total + ' reviews');
    });
  };

  var initialStars = parseFloat(badges[0].getAttribute('data-stars'));
  if (!isNaN(initialStars)) {
    badges.forEach(function (badge) {
      badge.querySelectorAll('.sp-tp__star').forEach(function (star) {
        star.style.setProperty('--tp-color', colorFor(initialStars));
      });
    });
  }

  var KEY = 'sp_trustpilot_v1';
  var TTL = 6 * 60 * 60 * 1000;
  try {
    var cached = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (cached && cached.bu === bu && Date.now() - cached.t < TTL) {
      render(cached);
      return;
    }
  } catch (e) {}

  var url = 'https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=' + encodeURIComponent(bu) + '&locale=en-US';
  fetch(url)
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (json) {
      var unit = json && json.businessUnit;
      if (!unit || !unit.numberOfReviews) return;
      var data = {
        bu: bu,
        t: Date.now(),
        total: unit.numberOfReviews.total,
        stars: unit.stars,
        score: unit.trustScore
      };
      render(data);
      try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
    })
    .catch(function () {});
})();
